import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from '@react-aria/utils';
import { CloseButton } from '../IconButton';
import { IconWrapper, ListItem, ListItemText } from './styles';
/**
 * An Icon List Item can be used to represent a list of options
 * with a left-hand icon displayed.
 * Optionally, a dismiss button can be shown on the right-hand side.
 * The icon container has a number of styling options.
 */
const IconListItem = (_a) => {
    var { Icon, iconBackgroundColor, iconBackgroundAlpha, iconBorderColor = 'transparent', noItemMargin, onDismiss, dismissButtonAriaLabel, condensed = false, children } = _a, props = __rest(_a, ["Icon", "iconBackgroundColor", "iconBackgroundAlpha", "iconBorderColor", "noItemMargin", "onDismiss", "dismissButtonAriaLabel", "condensed", "children"]);
    const uniqueId = useId();
    return (_jsxs(ListItem, Object.assign({ "$noItemMargin": noItemMargin }, props, { children: [_jsx(IconWrapper, { "$iconBackgroundAlpha": iconBackgroundAlpha, "$iconBackgroundColor": iconBackgroundColor, "$iconBorderColor": iconBorderColor, "$condensed": condensed, children: _jsx(Icon, {}) }), _jsx(ListItemText, { id: uniqueId, "$condensed": condensed, children: children }), onDismiss && (_jsx(CloseButton, { color: "white", "aria-label": dismissButtonAriaLabel, onPress: onDismiss, "aria-controls": uniqueId }))] })));
};
export default IconListItem;
//# sourceMappingURL=index.js.map